import { useEffect, useState } from "react";
import api, { downloadFile, getErrorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, Package, ShieldAlert, FileArchive } from "lucide-react";
import WordPackJobs from "@/pages/modules/WordPackJobs";

const catStyle = "bg-slate-100 text-slate-600 border-slate-300";

export default function ExportCenter({ id }) {
  const [d, setD] = useState(null);
  const [log, setLog] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/engagements/${id}/export-center`).then((r) => setD(r.data));
    api.get(`/engagements/${id}/access-log`).then((r) => setLog(r.data)).catch(() => {});
  }, [id]);

  const dl = async (e) => {
    try { await downloadFile(e.path, `${e.key}.${e.fmt === "json" ? "json" : e.fmt}`); toast.success(`Ekspor ${e.label} diunduh`); }
    catch (err) { toast.error(getErrorMessage(err) || "Gagal mengunduh"); }
  };
  const binder = async () => {
    setBusy(true);
    try { await downloadFile(`/engagements/${id}/binder/export`, `Binder_${id.slice(0, 8)}.zip`); toast.success("Binder ZIP diunduh"); api.get(`/engagements/${id}/access-log`).then((r) => setLog(r.data)); }
    catch (err) { toast.error(getErrorMessage(err)); } finally { setBusy(false); }
  };
  if (!d) return <div className="text-sm text-muted-foreground p-4">Memuat…</div>;

  const cats = [...new Set(d.exports.map((e) => e.category))];
  return (
    <div className="space-y-4" data-testid="export-center">
      <div className="bg-slate-900 text-slate-100 rounded-sm p-4 flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="font-head font-semibold flex items-center gap-2"><Package size={16} />Pusat Ekspor Universal</div>
          <div className="text-[12px] text-slate-300 mt-0.5">Unduh dokumen tunggal, atau bangun Binder Perikatan lengkap (ZIP) berisi indeks + seluruh berkas bukti.</div>
        </div>
        <Button size="sm" onClick={binder} disabled={busy} data-testid="binder-export"><FileArchive size={14} className="mr-1" />{busy ? "Menyusun…" : "Binder Lengkap (ZIP)"}</Button>
      </div>

      {cats.map((cat) => (
        <div key={cat}>
          <div className="text-xs font-head font-semibold uppercase text-muted-foreground mb-1">{cat}</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {d.exports.filter((e) => e.category === cat).map((e) => (
              <button key={e.key} onClick={() => dl(e)} data-testid={`export-${e.key}`}
                className="bg-white border border-border rounded-sm px-3 py-2 flex items-center gap-2 hover:border-slate-800 text-left">
                <Download size={14} className="text-slate-500 shrink-0" />
                <span className="text-xs flex-1">{e.label}</span>
                <span className={`text-[9px] px-1 py-0.5 border rounded-sm ${catStyle}`}>{e.fmt}</span>
              </button>
            ))}
          </div>
        </div>
      ))}

      <WordPackJobs id={id} />

      <div>
        <div className="text-xs font-head font-semibold uppercase text-muted-foreground mb-1 flex items-center gap-1"><ShieldAlert size={13} />Log Akses Dokumen (Keamanan)</div>
        <div className="bg-white border border-border rounded-sm overflow-x-auto" data-testid="access-log">
          <table className="w-full audit-table">
            <thead><tr><th>Waktu</th><th>Pengguna</th><th>Peran</th><th>Aksi</th><th>Objek</th><th>Kerahasiaan</th></tr></thead>
            <tbody>{log.slice(0, 30).map((l) => (
              <tr key={l.id} data-testid={`access-${l.id}`}>
                <td className="text-[11px]">{(l.at || "").slice(0, 19).replace("T", " ")}</td>
                <td className="text-xs">{l.user}</td><td className="text-xs">{l.role}</td>
                <td><span className={`text-[10px] px-1.5 py-0.5 border rounded-sm ${l.action === "DENIED" ? "bg-red-100 text-red-700 border-red-300" : "bg-slate-100 text-slate-600 border-slate-300"}`}>{l.action}</span></td>
                <td className="text-xs">{l.object}</td><td className="text-xs">{l.confidentiality}</td>
              </tr>
            ))}
              {log.length === 0 && <tr><td colSpan={6} className="text-center text-muted-foreground py-3">Belum ada aktivitas akses/unduh.</td></tr>}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
